import { Animation, AnimationController } from '@ionic/angular/standalone';

export type CenterModalAnimationOptions = {
  duration?: number;
  easing?: string;
  fromScale?: number;
};

export const createCenterModalAnimations = (
  animationController: AnimationController,
  options: CenterModalAnimationOptions = {}
): { enterAnimation: (baseEl: HTMLElement) => Animation; leaveAnimation: (baseEl: HTMLElement) => Animation } => {
  const {
    duration = 220,
    easing = 'cubic-bezier(0.2, 0, 0, 1)',
    fromScale = 0.92,
  } = options;

  const enterAnimation = (baseEl: HTMLElement): Animation => {
    const root = baseEl.shadowRoot;
    const backdropEl = root?.querySelector('ion-backdrop');
    const wrapperEl = root?.querySelector('.modal-wrapper');

    if (!backdropEl || !wrapperEl) {
      return animationController.create().addElement(baseEl).duration(duration).easing(easing);
    }

    const backdropAnimation = animationController
      .create()
      .addElement(backdropEl as HTMLElement)
      .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

    const wrapperAnimation = animationController
      .create()
      .addElement(wrapperEl as HTMLElement)
      .keyframes([
        { offset: 0, opacity: '0', transform: `scale(${fromScale})` },
        { offset: 1, opacity: '1', transform: 'scale(1)' },
      ]);

    return animationController
      .create()
      .addElement(baseEl)
      .easing(easing)
      .duration(duration)
      .addAnimation([backdropAnimation, wrapperAnimation]);
  };

  const leaveAnimation = (baseEl: HTMLElement): Animation => enterAnimation(baseEl).direction('reverse');

  return { enterAnimation, leaveAnimation };
};
